import SingleClientPageLayout from 'container/SingleClientPageLayout'

const SingleClient = () => {
	return <SingleClientPageLayout />
}

export default SingleClient
